<script lang="ts">
  import {
    Alignment,
    CSS_ALIGNMENT,
    CSS_SIZE,
    Size,
  } from "$components/editor/extensions/blocks/shared/attributes";
  import HoverMenu from "$components/editor/extensions/blocks/HoverMenu/HoverMenu.svelte";
  import GutterMenu from "../+shared/GutterMenu.svelte";
  import { NodeViewWrapper } from "svelte-tiptap";
  import type { NodeViewProps } from "@tiptap/core";

  export let updateAttributes: NodeViewProps["updateAttributes"];
  export let node: NodeViewProps["node"];
  export let deleteNode: NodeViewProps["deleteNode"];
  export let selected: NodeViewProps["selected"];
  export let isEditable: boolean;
  $$restProps; // prevent svelte unused props warning

  let error = false;

  const changeSize = (width: number | string) => {
    updateAttributes({
      width,
      height: "100%",
    });
  };
  const setAlign = (align: string) => {
    updateAttributes({
      align,
    });
  };

  $: attrs = node.attrs as {
    align: Alignment;
    width: Size;
    src: string;
    match: RegExpMatchArray;
    inline: boolean;
    height: number | string;
  };

  $: ({ align, width } = node.attrs);
  $: try {
    if (!attrs.src) error = true;
  } catch (e) {
    console.log(e);
    error = true;
  }
</script>

<NodeViewWrapper class="iframe not-prose group relative rounded">
  {#if isEditable}
    <GutterMenu on:delete-block={deleteNode} />
  {/if}

  {#if error}
    {#if isEditable}
      <div class="text-white">Failed to load url {attrs.src}</div>
    {/if}
  {:else}
    <div class="flex flex-row {CSS_ALIGNMENT[attrs.align]}" class:ring-4={isEditable && selected}>
      <iframe
        class="rounded {CSS_SIZE[attrs.width]} aspect-video"
        title="an spline embed"
        sandbox="allow-scripts allow-popups allow-forms allow-same-origin allow-top-navigation-by-user-activation"
        allowfullscreen
        loading="lazy"
        frameborder="0"
        height="100%"
        src={attrs.src}
      />
      {#if isEditable}
        <div
          class="absolute inset-x-0 bottom-0 z-[999] mb-2 hidden translate-y-full justify-center group-hover:flex"
        >
          <HoverMenu
            {align}
            {width}
            on:sizeChange={(e) => changeSize(e.detail)}
            on:alignChange={(e) => setAlign(e.detail)}
          />
        </div>
      {/if}
    </div>
  {/if}
</NodeViewWrapper>
